var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6729 7.02126C9.8395 5.65958 7.87098 5.65958 7.03759 7.02126L2.31997 14.7294C1.4449 16.1592 2.46795 18 4.13762 18H19.8622C21.5556 18 22.5746 16.1121 21.6517 14.6845L18.6481 10.0384C17.8065 8.73648 15.9109 8.73648 15.0692 10.0384L13.7595 12.0644L10.6729 7.02126Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.c67abe6ad4e31ea7935a50d1e127daa1.svg";
export { ForwardRef as ReactComponent };